import React from "react";
import notify from "devextreme/ui/notify";
import Form, {
  SimpleItem,
  GroupItem,
  Label,
  EmptyItem,
} from "devextreme-react/form";
import "devextreme-react/text-area";
import UserInfo from "../../UserInfo";
import {
  inserirOuAtualizar,
  criarCpbsDs,
  criarAlvaraFuncionamentoESanitarioDs,
  criarTaxasDs,
} from "../../DataSources";
import sysCodigoDescricao from "../../components/sysCodigoDescricao";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import { Button, ScrollView } from "devextreme-react";
import { TextBox, Button as TextBoxButton } from "devextreme-react/text-box";
import ShowError from "../../AppServices";
import CpbsBox from "../cpbs/CpbsBox";
import uiInfo from "../../ui-info";
//import { DataSource } from "devextreme/data/data_source/data_source";
import { abrirDetalhe } from "../../lancamentosUtils";
import DataSource from "devextreme/data/data_source";

var dataCorrente = new Date();

const template = {
  exibirPesqCpbs: false,
  exibirPreview: false,
  id: undefined,
  sequencial: undefined,
  prefeituraId: undefined,
  tipo: undefined,
  _uiNumero: undefined,
  ano: dataCorrente.getFullYear(),
  data: dataCorrente,
  dataDeVencimento: dataCorrente,
  tipoValidade: 1,
  validade: new Date(dataCorrente.getFullYear(), 11, 31),
  exercicio: dataCorrente.getFullYear(),
  inscricaoCpbs: undefined,
  cpbsId: undefined,
  historico: "",
  situacaoLancamento: "N",
  cobrancaId: undefined,
  _uiNome: "",
  _uiCpfCnpj: "-",
  preview: true,
  previewData: {
    nome: "",
    fantasia: "",
    cpfCnpj: "",
    enderedoL1: "",
    enderecoL2: "",
    ano: "",
    valor: undefined,
    situacao: "",
  },
};

export default class AlvaraFuncionamentoForm extends React.Component {
  constructor(props) {
    super(props);
    this.cpbsDs = criarCpbsDs();
    this.alvarasFuncionamentoDs = criarAlvaraFuncionamentoESanitarioDs();
    this.saidaProgramada = false;
    template.prefeituraId = UserInfo.getPrefeitura();
    this.state = { ...template };
    this.setCpbsId = this.setCpbsId.bind(this);
    this.setDadosCpbs = this.setDadosCpbs.bind(this);
    this.pesquisarCpbs = this.pesquisarCpbs.bind(this);
    this.onCpbsSelecionadoPesquisa = this.onCpbsSelecionadoPesquisa.bind(this);
    this.cpbsBoxRef = React.createRef();
    this.renderVeiculo = sysCodigoDescricao(
      () => this.state.cpbsId,
      this.setCpbsId,
      () => this.state._uiDescricaoCpbs,
      this.pesquisarCpbs
    );
    this.setDadosCpbs = this.setDadosCpbs.bind(this);
    this.atualizarInfoCpbs = this.atualizarInfoCpbs.bind(this);
    this.renderInfoCpbs = this.renderInfoCpbs.bind(this);

    this.cancel = this.cancel.bind(this);
    this.renderTxtCpbs = this.renderTxtCpbs.bind(this);
    this.onExercicioAlterado = this.onExercicioAlterado.bind(this);
    this.atualizarHistorico = this.atualizarHistorico.bind(this);

    this.confirmarTela = this.confirmarTela.bind(this);
    this.confirmarPopup = this.confirmarPopup.bind(this);
    this.itemLeitura = this.itemLeitura.bind(this);
    this.itemLeituraMoeda = this.itemLeituraMoeda.bind(this);
    this.taxasDs = [];
    this.taxasStore = new DataSource({
      store: {
        data: this.taxasDs,
        type: "array",
        key: "id",
      },
    });
    this.opcoesTaxa = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      value: this.state.cobrancaId,
      dataSource: this.taxasStore,
      valueExpr: "id",
      displayExpr: "descricao",
      onSelectionChanged: (e) =>
        this.setState({
          cobrancaId: e.selectedItem.id,
        }),
    };

    this.tipoValidadeOpcoes = {
      dataSource: [
        { id: 1, descricao: "Permanente" },
        { id: 2, descricao: "Provisório" },
        { id: 3, descricao: "Prorrogação" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    // this.opcoesTaxaTLAS = {
    //   editorType: "dxSelectBox",
    //   searchEnabled: true,
    //   dataSource: criarTaxasDs("TLAS"),
    //   valueExpr: "sequencial",
    //   displayExpr: "descricao",
    // };
  }

  onExercicioAlterado(e) {
    if (e.event) {
      this.atualizarHistorico();
    }
  }

  atualizarHistorico() {
    const fExercicio = this.state.exercicio;

    const exercicioOk = fExercicio !== undefined && fExercicio !== 0;
    const tipoTexto =
      this.state.tipo === "F" ? "DE FUNCIONAMENTO" : "SANITÁRIO";

    if (exercicioOk) {
      const historico = `REF. TAXA ALVARÁ ${tipoTexto} EXERCÍCIO ${fExercicio}.`;
      this.setState({ historico });
    }
  }

  renderInfoCpbs(data) {
    return (
      <React.Fragment>
        <div
          style={{
            width: "100%",
            height: "35px",
            display: "flex",
            alignItems: "center",
            backgroundColor: "#D7DBDD",
          }}
        >
          <div style={{ padding: "15px" }}>
            <span style={{ fontWeight: "bold", paddingRight: "5px" }}>
              CPF/CNPJ:
            </span>{" "}
            {this.state.cpfCnpj}
          </div>
          <div style={{ padding: "15px", flexGrow: "1" }}>
            <span style={{ fontWeight: "bold", paddingRight: "5px" }}>
              Nome/Razão Social
            </span>{" "}
            {this.state.nome}
          </div>
        </div>
      </React.Fragment>
    );
  }

  setCpbsId(data) {
    this.setState({ inscricaoCpbs: data.value });
    this.atualizarInfoCpbs();
  }

  atualizarInfoCpbs() {
    this.cpbsDs
      .load({ filter: [["inscricao", "=", this.state.inscricaoCpbs]] })
      .then((result) => {
        if (result.length !== 0) {
          this.setDadosCpbs(result[0]);
        } else {
          this.setDadosCpbs(undefined);
        }
        this.atualizarHistorico();
      })
      .catch((_) => this.setDadosCpbsErro());
  }

  setDadosCpbs(cpbs) {
    if (cpbs === undefined) {
      this.setState({
        cpfCnpj: "",
        nome: "",
        area: undefined,
      });
    } else {
      this.setState({
        cpfCnpj: cpbs.contribuinte.cpfCnpjFormatado,
        nome: cpbs.contribuinte.nome,
        area: this.state.tipo == "F" ? cpbs.unidadesTllf : cpbs.unidadesTlas,
      });
    }
  }

  setDadosCpbsErro() {
    this.setState({ _uiNomeContribuinte: "<<ERRO>>" });
  }

  onCpbsSelecionadoPesquisa(e) {
    this.setState({
      inscricaoCpbs: e.row.data.inscricao,
      exibirPesqCpbs: false,
    });
    this.atualizarInfoCpbs();
  }

  pesquisarCpbs() {
    this.cpbsBoxRef.current.limparFiltro();
    this.setState({ exibirPesqCpbs: true });
  }

  renderTxtCpbs() {
    return (
      <TextBox value={this.state.inscricaoCpbs} onValueChanged={this.setCpbsId}>
        <TextBoxButton
          name="btnPesquisa"
          location="after"
          options={{ icon: "search", onClick: this.pesquisarCpbs }}
        />
      </TextBox>
    );
  }

  async componentDidMount() {
    if (this.props.match.path === "/alvara_funcionamento/:id?") {
      let taxasData = await criarTaxasDs("TLLF").load();
      taxasData.map((x) => {
        this.taxasDs.push(x);
      });
    } else {
      let taxasData = await criarTaxasDs("TLAS").load();
      taxasData.map((x) => {
        this.taxasDs.push(x);
      });
    }

    const tipo =
      this.props.match.path === "/alvara_funcionamento/:id?" ? "F" : "S";
    const tipoServico = tipo === "F" ? "TLLF" : "TLAS";

    //await this.opcoesTaxaTLLF.dataSource.load();
    //await this.opcoesTaxaTLAS.dataSource.load();

    if (this.props.match.params.id !== undefined) {
      this.alvarasFuncionamentoDs
        .load({
          filter: [
            ["sequencial", "=", this.props.match.params.id],
            ["tipoStr", "=", tipoServico],
          ],
        })
        .then((response) => {
          console.log("response alvara api", response);
          if (response.length < 1) {
            notify("Registro não encontrado.", "error");
            this.props.history.goBack();
          } else {
            const data = response[0];

            if (data.tipoStr !== tipoServico) {
              ShowError(
                `Inconsistência do tipo de alvará: Back-end: '${data.tipoStr}) != Front-end: ${tipoServico}'`
              );
              this.props.history.goBack();
            }

            let inscricaoCpbs;
            if (data.cpbsLancamento != undefined) {
              inscricaoCpbs = data.cpbsLancamento.inscricao;
            }

            console.log("alvara taxa", data.taxa);

            let taxaId = data.taxa == undefined ? null : data.taxa.id;

            let novoEstado = {
              _uiNumero: data.numeroCompleto,
              inscricaoCpbs,
              numero: data.numeroLancamento,
              id: data.id,
              sequencial: data.sequencial,
              tipo: tipo,
              prefeituraId: data.prefeituraId,
              ano: data.ano,
              data: data.dataLancamento,
              dataDeVencimento: data.vencimentoAlvara,
              validade: data.validadeLancamento,
              exercicio: data.exercicio,
              historico: data.historico,
              nome: data.contribuinte.nome,
              cpfCnpj: data.contribuinte.documentoFormatado,
              situacaoLancamento: data.situacaoStr,
              cobrancaId: taxaId,
              preview: true,
              area: data.qtdeLancamento,
              mesesProporcional: data.mesesProporcional,
              dataCotaUnica: data.vencimentoCotaUnica,
              descontoCotaUnica: data.percDescontoCotaUnica,
              _uiNome: data.contribuinte.nome,
              _uiCpfCnpj: data.contribuinte.documentoFormatado,
              tipoValidade: data.tipoValidadeAlvara,
            };

            console.log("novo estado", novoEstado);

            this.abrindo = true;

            console.log("chegou aqui alvara");

            this.setState(novoEstado);
          }
        })
        .catch((erro) => {
          ShowError(erro);
          this.props.history.goBack();
        });
    } else {
      const store = tipo == "F" ? criarTaxasDs("TLLF") : criarTaxasDs("TLAS");
      const dataSource = new DataSource(store);
      dataSource
        .load()
        .done((result) => {
          console.log("dados filtrados", store);
          this.setState(
            {
              tipo,
              //cobrancaId: result.length === 1 ? result[0].id : undefined,
            },
            () => {
              this.atualizarHistorico();
            }
          );
        })
        .fail((error) => {
          ShowError(error);
        });
    }
  }

  itemLeitura(data) {
    if (this.state.previewData == undefined) {
      return <span></span>;
    }
    return <span>{this.state.previewData[data.dataField]}</span>;
  }

  itemLeituraMoeda(data) {
    let valor;
    if (this.state.previewData != undefined) {
      valor = this.state.previewData[data.dataField];
    }
    let str = "";
    if (valor !== undefined) {
      str = valor.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      });
    }

    return <span>{str}</span>;
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <form>
            <Form formData={this.state} colCount={2}>
              <GroupItem
                caption={
                  this.state.tipo === "F"
                    ? "ALVARÁ DE FUNCIONAMENTO"
                    : "ALVARÁ SANITÁRIO"
                }
                colSpan={2}
                colCount={4}
              >
                <SimpleItem
                  colSpan={1}
                  dataField={"_uiNumero"}
                  editorType={"dxTextBox"}
                  editorOptions={{ readOnly: true }}
                >
                  <Label text="Número" />
                </SimpleItem>

                <EmptyItem colSpan={3} />

                <SimpleItem
                  colSpan={1}
                  dataType={"date"}
                  dataField={"data"}
                  editorType={"dxDateBox"}
                  editorOptions={{ width: "100%" }}
                >
                  <Label text="Data" />
                </SimpleItem>

                <EmptyItem colSpan={3} />

                <SimpleItem
                  colSpan={1}
                  dataType={"date"}
                  dataField={"dataDeVencimento"}
                  editorType={"dxDateBox"}
                  editorOptions={{ width: "100%", useMaskBehavior: true }}
                >
                  <Label text="Vencimento" />
                </SimpleItem>

                <EmptyItem colSpan={3} />

                <SimpleItem
                  colSpan={1}
                  dataField={"validade"}
                  editorType={"dxDateBox"}
                  editorOptions={{ width: "100%", useMaskBehavior: true }}
                >
                  <Label text="Validade" />
                </SimpleItem>

                <EmptyItem colSpan={3} />

                <SimpleItem
                  colSpan={1}
                  dataField={"exercicio"}
                  editorType={"dxTextBox"}
                  editorOptions={{ onValueChanged: this.onExercicioAlterado }}
                >
                  <Label text="Exercício" />
                </SimpleItem>

                <EmptyItem colSpan={3} />

                <SimpleItem colSpan={1} render={this.renderTxtCpbs}>
                  <Label text="CPBS" />
                </SimpleItem>

                <SimpleItem
                  colSpan={1}
                  dataField={"cpfCnpj"}
                  editorType={"dxTextBox"}
                  editorOptions={{ readOnly: true }}
                >
                  <Label text="CPF/CNPJ" />
                </SimpleItem>

                <SimpleItem
                  colSpan={2}
                  dataField={"nome"}
                  editorType={"dxTextBox"}
                  editorOptions={{ readOnly: true }}
                >
                  <Label text="Nome/Razão Social" />
                </SimpleItem>

                <SimpleItem
                  colSpan={1}
                  dataField={"area"}
                  editorType={"dxNumberBox"}
                  editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                  cssClass={"txtFrmCpbsNumerico"}
                >
                  <Label text="Base Cálculo" />
                </SimpleItem>

                <SimpleItem
                  colSpan={3}
                  dataField={"cobrancaId"}
                  editorType={"dxLookup"}
                  editorOptions={this.opcoesTaxa}
                >
                  <Label text="Taxa" />
                </SimpleItem>

                <SimpleItem
                  colSpan={1}
                  dataField={"tipoValidade"}
                  editorType={"dxSelectBox"}
                  editorOptions={this.tipoValidadeOpcoes}
                >
                  <Label text="Tipo Alvará" />
                </SimpleItem>

                <SimpleItem
                  colSpan={1}
                  dataField={"mesesProporcional"}
                  editorType={"dxNumberBox"}
                  cssClass={"txtNumerico"}
                >
                  <Label text="Meses Proporcional" />
                </SimpleItem>

                <SimpleItem
                  colSpan={1}
                  dataField={"dataCotaUnica"}
                  editorType={"dxDateBox"}
                  editorOptions={{
                    showClearButton: true,
                    useMaskBehavior: true,
                    width: "100%",
                  }}
                >
                  <Label text="Data Cota Única" />
                </SimpleItem>

                <SimpleItem
                  colSpan={1}
                  dataField={"descontoCotaUnica"}
                  editorType={"dxNumberBox"}
                  editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                  cssClass={"txtNumerico"}
                >
                  <Label text="% Desc. Conta Única" />
                </SimpleItem>

                <SimpleItem
                  dataField={"historico"}
                  colSpan={4}
                  editorType="dxTextArea"
                  editorOptions={{ height: 90 }}
                >
                  <Label text="Histórico" />
                </SimpleItem>
              </GroupItem>
            </Form>
            <div style={{ marginTop: "10px" }}>
              <div style={{ display: "inline-block" }}>
                <Button
                  width={120}
                  text="Pré-visualizar"
                  type="default"
                  onClick={this.confirmarTela}
                />
              </div>

              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button
                  width={120}
                  text="Salvar"
                  type="success"
                  onClick={this.confirmarPopup}
                />
              </div>

              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button text="Cancelar" onClick={this.cancel} />
              </div>
            </div>
          </form>
          <Popup
            visible={this.state.exibirPesqCpbs}
            onHiding={(e) => this.setState({ exibirPesqCpbs: false })}
            dragEnabled={false}
            closeOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            width={"90%"}
            height={"90%"}
            title="Pesquisar CPBS"
          >
            <ScrollView showScrollbar={"always"}>
              <CpbsBox
                onSelecionado={this.onCpbsSelecionadoPesquisa}
                ref={this.cpbsBoxRef}
              />
            </ScrollView>
            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Fechar",
                type: "default",
                width: 150,
                onClick: () => this.setState({ exibirPesqCpbs: false }),
              }}
            ></ToolbarItem>
          </Popup>
          <Popup
            visible={this.state.exibirPopupPreview}
            onHiding={(e) => this.setState({ exibirPopupPreview: false })}
            dragEnabled={false}
            closeOnOutsideClick={false}
            showCloseButton={false}
            showTitle={true}
            width={600}
            height={350}
            title="Confirmação dos dados"
          >
            <ScrollView showScrollbar="always">
              <form>
                <Form formData={this.state.previewData}>
                  <SimpleItem dataField={"nome"} render={this.itemLeitura}>
                    <Label text="Nome" />
                  </SimpleItem>

                  <SimpleItem dataField={"cpfCnpj"} render={this.itemLeitura}>
                    <Label text="CPF/CNPJ" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"enderecoL1"}
                    render={this.itemLeitura}
                  >
                    <Label text="Endereco" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"enderecoL2"}
                    render={this.itemLeitura}
                  >
                    <Label text=" " showColon={false} />
                  </SimpleItem>

                  <SimpleItem dataField={"ano"} render={this.itemLeitura}>
                    <Label text="Ano" showColon={false} />
                  </SimpleItem>

                  <SimpleItem dataField={"exercicio"} render={this.itemLeitura}>
                    <Label text="Exercício" />
                  </SimpleItem>

                  <SimpleItem dataField={"taxa"} render={this.itemLeitura}>
                    <Label text="Taxa" />
                  </SimpleItem>

                  <SimpleItem dataField={"situacao"} render={this.itemLeitura}>
                    <Label text="Situação" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"valor"}
                    render={this.itemLeituraMoeda}
                  >
                    <Label text="Valor" />
                  </SimpleItem>
                </Form>
              </form>
            </ScrollView>
            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Confirmar",
                type: "success",
                width: 150,
                onClick: this.confirmarPopup,
              }}
            ></ToolbarItem>
            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Cancelar",
                type: "default",
                width: 150,
                onClick: () => this.setState({ exibirPopupPreview: false }),
              }}
            ></ToolbarItem>
          </Popup>
        </div>
      </React.Fragment>
    );
  }

  confirmarTela() {
    this.confirmar(this.state.preview);
  }

  confirmarPopup() {
    this.confirmar(false);
  }

  confirmar(preview) {
    let entidade = { ...this.state };
    entidade.preview = preview;
    console.log("dados alvará", entidade);
    inserirOuAtualizar(this.alvarasFuncionamentoDs, entidade).then(
      function (data) {
        console.log("dados ret API", data);
        if (preview) {
          this.setState({
            exibirPopupPreview: true,
            previewData: {
              nome: data.lancamento.contribuinte.nome,
              fantasia: data.lancamento.contribuinte.fantasia,
              cpfCnpj: data.lancamento.contribuinte.documentoFormatado,
              enderecoL1: data.lancamento.contribuinte.logradouroComNumero,
              enderecoL2: data.lancamento.contribuinte.enderecoL2,
              ano: data.lancamento.ano,
              exercicio: data.lancamento.exercicio,
              valor: data.lancamento.valorDoImposto,
              situacao: data.lancamento.situacao.descricao,
              taxa: data.lancamento.taxa.descricao,
              valor: data.lancamento.valorDoImposto,
            },
          });
        } else {
          abrirDetalhe(this.props.history, data);
        }
      }.bind(this)
    );
  }

  cancel() {
    notify("Operação cancelada", "warning");
    this.props.history.goBack();
  }
}
